import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import swal from 'sweetalert';

import {withStyles} from '@material-ui/core/styles';
import red from '@material-ui/core/colors/red';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';

class DeleteButton extends React.Component {

    static propTypes = {
        href: PropTypes.string.isRequired,
        confirmMessage: PropTypes.string,
        successMessage: PropTypes.string,
        errorMessage: PropTypes.string,
        handleSuccess: PropTypes.func,
    };

    static defaultProps = {
        confirmMessage: '',
        successMessage: '',
        errorMessage: '',
    };

    async onDeleteClicked() {
        const confirm = await swal({
            text: this.props.confirmMessage,
            dangerMode: true,
            buttons: true,
        });

        if (confirm) {
            // Confirmed to delete item.
            await this.deleteItem();
        }
    }

    async deleteItem() {
        try {
            // Send request.
            await axios.delete(this.props.href);

            // Show success message.
            await swal({
                text: this.props.successMessage,
                icon: "success",
            });

            // Refresh page to update data.
            this.props.handleSuccess ? this.props.handleSuccess() : location.reload()
        } catch (e) {
            // Prefer a specific message returned by the server for client
            // errors (4xx), otherwise fall back to the generic error message.
            let text = this.props.errorMessage;

            if (e.response && e.response.status >= 400 && e.response.status < 500
                && e.response.data && e.response.data.message) {
                text = e.response.data.message;
            }

            swal({
                text: text,
                icon: "error",
            });
        }
    }

    render() {
        const {classes} = this.props;

        return (
            <IconButton
                className={classes.dangerButton}
                onClick={this.onDeleteClicked.bind(this)}
                title={this.props.text}
            >
                <Icon>delete</Icon>
            </IconButton>
        );
    }
}

const styles = theme => ({
    dangerButton: {
        color: red[500],
    },
});

export default withStyles(styles)(DeleteButton);



// WEBPACK FOOTER //
// ./resources/assets/js/components/Form/DeleteButton.js